import { schema } from 'normalizr'

export const request_reasonInput = new schema.Entity('request_reasons', {
  
}, {
  idAttribute: 'uuid'
})